import { render, staticRenderFns } from "./couponLayout4.vue?vue&type=template&id=ed42f686&"
import script from "./couponLayout4.vue?vue&type=script&lang=ts&"
export * from "./couponLayout4.vue?vue&type=script&lang=ts&"
import style0 from "./couponLayout4.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports